// extracted by mini-css-extract-plugin
export var promotionLink = "_v3-0";